var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCameraRotationMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.0937 9.25814C17.544 7.20661 16.1512 5.60614 14.388 4.72962M9.38443 4.22982C5.59089 5.2463 3.33964 9.14558 4.35612 12.9391C4.93734 15.1083 6.46112 16.7732 8.36874 17.6112",
    stroke: "#2264C2",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.48128 14.5954L9.40152 18.0298L5.96712 18.95",
    stroke: "#2264C2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9679 7.60384L13.0477 4.16944L16.4821 3.24919",
    stroke: "#2264C2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2623 15.1096C17.8942 14.4719 17.0787 14.2534 16.441 14.6216C15.8198 14.9802 15.5964 15.7633 15.9255 16.393L13.2871 11.8231C12.9189 11.1854 12.1034 10.9669 11.4657 11.3351C10.828 11.7033 10.6095 12.5187 10.9777 13.1565L14.9774 20.085L13.6439 17.7753L12.9537 20.3511C12.7706 21.0342 12.8665 21.7621 13.2201 22.3746L14.0011 23.7278L14.1155 23.926C14.4691 24.5384 15.0516 24.9854 15.7347 25.1684L17.3184 25.2564C18.2242 25.3067 19.0587 25.7642 19.5882 26.501L20.6673 28.0026M18.2623 15.1096L19.5955 17.4187M18.2623 15.1096C17.8942 14.4719 18.1131 13.6564 18.7509 13.2882C19.3886 12.92 20.2041 13.1385 20.5722 13.7763L21.2274 14.9111C20.8742 14.2762 21.0947 13.4731 21.7261 13.1085C22.3639 12.7404 23.1793 12.9589 23.5475 13.5966L25.3259 16.6763C25.3352 16.6924 25.3445 16.7087 25.3536 16.7249L25.5475 17.0607C25.6237 17.1926 25.6747 17.3321 25.7022 17.4738C25.9999 18.2694 26.1048 19.129 26.0021 19.9809V19.9809C25.9121 20.7283 26.1189 21.4813 26.5781 22.0778L28.0007 23.926",
    stroke: "#8CB5F0",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9766 20.0859L13.6432 17.7765",
    stroke: "#8CB5F0",
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9277 16.2617L18.2611 15.107",
    stroke: "#8CB5F0",
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6191 17.5938L15.9525 16.439",
    stroke: "#8CB5F0",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraRotationMobile);
export default __webpack_public_path__ + "static/media/CameraRotationMobile.d4fd8173e0608ff73ebe5eb1b53ad47c.svg";
export { ForwardRef as ReactComponent };